import React, { Component } from "react";
import axios from "axios";

// components
import Form2Header from "./Form2Header";
import { customAlphabet } from "nanoid";

// validators
import validator from "validator";
import validate from "is-my-date-valid";
import { withRouter } from 'react-router-dom';



import baseurl from "./baseurl";

// Styles
import "../styles/Form2.css";

class Form2 extends Component {
  nanoid = customAlphabet('1234567890', 8)

  state = {
    pid: this.nanoid(),
    screeningDate: "",
    referringPhysician: "",
    patientName: "",
    cellNumber: "",
    dob: "",
    gender: "",
    email: "",
    errorMessage: "",
    confirmationAlert: false,
    loading: false,
  };

  onChange = (e) => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    this.setState({
      [e.target.name]: value,
    });
  };

  redirect = () => {
    this.props.history.push('/thank-you')
  }
    

  handleAlert = () => {
    this.setState({
      errorMessage: "",
    });
  };

  onSubmit = (e) => {
    e.preventDefault();
    const mandateFields = [
      this.state.screeningDate,
      this.state.referringPhysician,
      this.state.patientName,
      this.state.cellNumber,
      this.state.dob,
      this.state.gender,
      this.state.email,
    ];
    console.log(this.state);

    if (
      !mandateFields.includes("") &&
      !mandateFields.includes(null) &&
      !mandateFields.includes(undefined)
    ) {
      this.setState({
        loading: true,
      });
      console.log("form submitted");
      axios
        .post(`${baseurl}/form1/form2`, this.state)
        .then((response) => {
          console.log(response);

          if (response.status === 200) {
            this.setState({
              loading: false,
            });

            // empty the state
            this.setState({});
            
            this.redirect();
           
          } else
            this.setState({
              errorMessage: "Something went wrong, please try again later",
            });
        })
        .catch((error) => {
          this.setState({
            errorMessage: error,
          });
        });
    } else {
      console.log("form not submitted");
      this.setState({
        errorMessage: "All fields marked with * are mandatory",
      });
    }
  };

  render() {
    const valid = validate({ format: "MM/DD/YYYY" });

    const { screeningDate, cellNumber, dob, email } = this.state;

    return (
      <div>
        <div className="dhat_main">
          <div className="dhat_wrraper">
            <Form2Header />
            <div className="meddile_header">
              <h2>
                Referral for Direct Schedule Screening Colonoscopy with <br />
                Dr. Yamini Maddala
                <br />
              </h2>
            </div>

            {/* Errors are shown here */}
            {this.state.errorMessage && (
              <div className="alert">
                <span className="closebtn" onClick={this.handleAlert}>
                  &times;
                </span>
                {this.state.errorMessage}
              </div>
            )}

            {/* FORM - START */}
            <form className="screening_form">
              <div className="initial_info">
                <div className="pdate_left">
                  <p className="label">
                    Screening Date<span className="mandate">*</span>:
                  </p>
                  <input
                    name="screeningDate"
                    id="currentdate"
                    type="tel"
                    maxLength="10"
                    onChange={(e) =>
                      this.setState({ screeningDate: e.target.value })
                    }
                    placeholder="mm/dd/yyyy"
                  />
                  {valid(screeningDate) ? null : screeningDate === "" ? null : (
                    <span className="error">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-20 w-20 mr-2"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                          clipRule="evenodd"
                        />
                      </svg>
                      Please enter valid date (mm/dd/yyyy)
                    </span>
                  )}
                </div>
                <div className="referring_phy">
                  <p className="label">
                    Referring Physician<span className="mandate">*</span>:
                  </p>
                  <input
                    name="referringPhysician"
                    id="referringPhysician"
                    type="text"
                    maxLength="59"
                    onChange={(e) =>
                      this.setState({ referringPhysician: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="patient_primary_info">
                <div className="patient_name">
                  <p className="label">
                    Patient Name<span className="mandate">*</span>:
                  </p>
                  <input
                    type="text"
                    name="patientName"
                    maxLength="59"
                    onChange={this.onChange}
                    required
                  />
                </div>
                <div className="pdob_center">
                  <p className="label">
                    DOB<span className="mandate">*</span>:
                  </p>
                  <input
                    name="dob"
                    id="dateofbirth"
                    type="tel"
                    maxLength="10"
                    onChange={(e) => this.setState({ dob: e.target.value })}
                    placeholder="mm/dd/yyyy"
                  ></input>
                  {valid(dob) ? null : dob === "" ? null : (
                    <span className="error">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-20 w-20 mr-2"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                          clipRule="evenodd"
                        />
                      </svg>
                      Please enter valid date (mm/dd/yyyy)
                    </span>
                  )}
                </div>
              </div>
              <div className="patient_primary_info">
                <div className="gender_info">
                  <p className="label">
                    Sex<span className="mandate">*</span>:
                  </p>
                  <input
                    type="radio"
                    name="gender"
                    value="male"
                    onChange={this.onChange}
                    required
                  />
                  <p>Male</p>
                  <div className="pfemale">
                    <input
                      type="radio"
                      name="gender"
                      value="female"
                      onChange={this.onChange}
                      required
                    />
                    <p>Female</p>
                  </div>
                  <div className="ptransgender">
                    <input
                      type="radio"
                      name="gender"
                      value="Transgender"
                      onChange={this.onChange}
                      required
                    />
                    <p>Transgender</p>
                  </div>
                </div>
              </div>
              <div className="patient_secondary_info">
                <div className="p_pnone">
                  <p className="label">
                    Cell Number<span className="mandate">*</span>:
                  </p>
                  <input
                    type="text"
                    id="yourphone"
                    name="cellNumber"
                    onChange={this.onChange}
                  />
                  {cellNumber.length === 12 ? null : cellNumber ===
                    "" ? null : (
                    <span className="error">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-20 w-20 mr-2"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                          clipRule="evenodd"
                        />
                      </svg>
                      Please enter valid phone number
                    </span>
                  )}
                </div>
                <div className="p_email_add flex">
                  <p className="label">
                    Email Address<span className="mandate">*</span>:
                  </p>
                  <input
                    type="email"
                    name="email"
                    maxLength="59"
                    onChange={this.onChange}
                    required
                  />
                  {validator.isEmail(email) ? null : email === "" ? null : (
                    <span className="error w-100">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-20 w-20 mr-2"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                          clipRule="evenodd"
                        />
                      </svg>
                      Please enter valid email
                    </span>
                  )}
                </div>
              </div>
            </form>
            <div className="submit_form">
              <input
                type="button"
                name="waq_submit1"
                value="Submit"
                onClick={this.onSubmit}
              />
            </div>
            <div className="pdetails_bottom_section">
              <div className="pdtails_bottim1">
                <p>
                  <span className="email_b">Email</span> the following
                  information to{" "}
                  <span className="email_color">
                    <a href="mailto:info@YaminiMaddalaMD.com">
                      info@YaminiMaddalaMD.com
                    </a>{" "}
                  </span>{" "}
                  <span className="fax_text">Or Fax to</span>{" "}
                  <span className="fax_n">(469) 697-5105</span>
                </p>
              </div>
              <div className="pdtails_bottim2">
                <p>
                  If you have questions about uploading into the Leading Reach/
                  FibroBlast Referral platform{" "}
                  <span className="please-text">
                    Please call our office at (469) 697-5100.
                  </span>
                </p>
              </div>
              <div className="pdtails_bottim3">
                <p>
                  **In order to facilitate your patient in a timely manner
                  please email or fax the following information:{" "}
                </p>
                <ul>
                  <li>This Direct Schedule Screening Colonoscopy Form</li>
                  <li>Current medical records along with recent labs</li>
                  <li>Patient demographic/Insurance info/Referral Sheet</li>
                </ul>
              </div>
              <div className="pdtails_bottim4">
                <div className="thanks_text_1">
                  Thank you for entrusting Dr Maddala with your patient’s health
                  care needs and supporting us in the prevention of colorectal
                  cancer!!
                </div>
                <div className="thanks_text_2">Leaders in Digestive Health</div>
                <div className="thanks_text_3">
                  981 State Highway 121 Suite 1140, Allen, TX 75013
                </div>
              </div>
            </div>
            <div className="pdetails_fbottom">
              <p>
                <span className="footer_color">Office</span> 469-697-5100{" "}
                <span className="footer_color">/ Fax</span> 469-697-5105{" "}
                <span className="footer_color">/ www.yaminimaddalamd.com</span>
              </p>
            </div>
          </div>
        </div>
        {/* overlay loader */}
        {this.state.loading ? (
          <div className="loader-container">
            <div className="loader-content">
              <div className="loader"></div>
              <span className="loader-text">Submitting...</span>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    );
  }
}

export default withRouter(Form2)